var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.MallBrandService}},[_c('TableText',{attrs:{"prop":"display_name","label":"品牌名","width":120}}),_c('TableText',{attrs:{"prop":"enterprise.display_name","label":"所属企业","width":160}}),_c('TableText',{attrs:{"prop":"mall_classify.display_name","label":"分类名","width":120}}),_c('TableImage',{attrs:{"prop":"logo","label":"LOGO"}}),_c('TableImage',{attrs:{"prop":"cover_img","label":"封面图"}}),_c('TableAction',{attrs:{"buttons":[
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":160}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }